import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/$slug/admin/operators")({
  staticData: { title: "Operators" },
  component: lazyRouteComponent(
    () => import("#pages/authenticated/admin/operators/page.tsx"),
    "OperatorsPage",
  ),
})
